export const heroOne = {
	reverse: false,
	inverse: false,
	topLine: {
		text: 'Uniqueness',
	},
	headline: 'Why us? ',
	description: ['Access to information is crucial to all human beings, especially often-marginalised groups such as women and girls.',
		' Libraries around the globe empower women, bridge the education gap.',
		'It improve women’s confidance, welfare and position in society.',],
	linkTo: '/more',
	imgStart: 'start',
	img: './assets/svg/Deal.svg',
	start: 'true',
};

export const heroTwo = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Rules and regulations',
	},
	headline: "Guidelines",
	description: ['Strict silence and discipline must be maintained in the library',
		'Smoking, eating and talking loudly are strictly prohibited in the library',
		'Readers should not mark, underline, write, tear pages or damage the library documents.',
		'Suggestions on all aspects of library services are welcome.'],
	imgStart: 'start',
	img: './assets/svg/Connection.svg',
	start: 'true',
};

export const heroThree = {
	reverse: false,
	inverse: false,
	topLine: {
		text: '',
	},
	headline: 'Contact Us? ',
	description: ['', 'Name : Meena Nagarwal', 'Mobile No    :    8619962720', 'E-mail : anushkanagarwal72@gmail.com', '1 Day demo is free.'],
	linkTo: '/more',
	imgStart: 'start',
	img: './assets/svg/mom.jpg',
	start: 'true',
};

